export { UserAccessLevel, ApplicationSection, AssistantSection };

const UserAccessLevel = {
  WHITELABELUSER: "WHITELABELUSER",
  WHITELABELOWNER: "WHITELABELOWNER",
  WHITELABELVIEWER: "WHITELABELVIEWER",
  WHITELABELOPERATOR: "WHITELABELOPERATOR",
} as const;

type UserAccessLevel = (typeof UserAccessLevel)[keyof typeof UserAccessLevel]

const ApplicationSection = {
  Threads: "threads",
  Contacts: "contacts",
  Settings: "settings",
  Campaigns: "campaigns",
  Pipelines: "pipelines",
  Dashboard: "dashboard",
  Assistants: "assistants",
  Integrations: "integrations",
  "Voice Library": "voiceLibrary",
  "Knowledge Bases": "knowledgebases",
} as const;

type ApplicationSection = (typeof ApplicationSection)[keyof typeof ApplicationSection];

const AssistantSection = {
  Tools: "tools",
  Prompt: "prompt",
  Widget: "widget",
  Settings: "settings",
  Dashboard: "dashboard",
  // Checkpoints: "checkpoints",
  // Changelogs: "changelog",
  "Assistant Coach": "assistantCoach",
  "Phone Numbers": "phoneNumbers",
  "Facebook Pages": "facebookPages",
  "Knowledge Base": "knowledgebase",
  "Instagram Pages": "instagramPages",
  "Automated Testing": "evalRuns",
} as const;

type AssistantSection = (typeof AssistantSection)[keyof typeof AssistantSection];
